export default "__VITE_ASSET__DE8p9ViC__"